import React from "react";
import Modal from "react-bootstrap/Modal";

export const ModalCauHinhTatToan = ({ show, onHide, onConfirm }) => {
    return (
        <Modal show={show} onHide={onHide} centered className="modal-new modal-fade" size="sm">
            <Modal.Header>
                <h4  className="modal-title color7-bold ml-1"style={{marginLeft: 15, marginTop: 15}}>Cảnh báo</h4>
                <button type="button" className="close-popup-new" onClick={onHide}>
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body className="p-2 text-center">
                <p style={{ fontSize: '16px', color: 'red'}}>
                    Lưu ý cẩn trọng khi sử dụng chức năng này!!!<br/>
                    Bạn có chắc chắn muốn bật cấu hình tất toán?
                </p>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide}>
                    KHÔNG DÙNG
                </button>
                <button type="button" className="btn btn-new-main btn-success" onClick={onConfirm}>
                    CÓ DÙNG
                </button>
            </Modal.Footer>
        </Modal>
    );
};